import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { POST_LOGIN_REDIRECTS } from "../utils/referral";

export default function PublicRoute({ children }) {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return null; // 尚未初始化，避免畫面閃爍
  }

  // ✅ 白名單：允許已登入者仍可停留
  //   2026-07-30 加入 forget/reset-password：Google 登入者忘記自己設過的密碼（EXE 登入用同一組）時，
  //   未登出就進不去重設頁 → EXE 的「忘記密碼」連結與信件內的重設連結對已登入者都會失效。
  const allowEvenWhenAuthed = [
    "/strategydemo",
    "/admin/login",
    "/authentication/2fa",
    "/mt5-scheduler",
    "/authentication/forget-password",
    "/authentication/reset-password",
  ];

  // ✅ 若已登入且目前頁面不在白名單內 → 導向目標頁
  if (isAuthenticated && !allowEvenWhenAuthed.includes(location.pathname)) {
    // 2026-06-16：已登入者帶 ?redirect=coin / ?price= 進登入頁時，仍要導到指定目標
    //   （原本一律導 /mas-genie，會吃掉官網的 redirect 參數 → 已登入點官網連結跑錯位置）
    //   未登入者走原流程：sign-in 頁掛載時 saveReferralCodeFromUrl 存 postLoginRedirect，登入後 getAuthRedirectPath 取用
    const params = new URLSearchParams(location.search.replace(/\?/g, "&"));
    const redirect = params.get("redirect");
    const price = params.get("price");
    let target = "/mas-genie";
    if (redirect && POST_LOGIN_REDIRECTS[redirect]) {
      target = POST_LOGIN_REDIRECTS[redirect];
    } else if (price || location.search.includes("price=")) {
      target = POST_LOGIN_REDIRECTS.plans;
    }
    return <Navigate to={target} replace />;
  }

  // ✅ 未登入或白名單頁面 → 顯示內容
  return children;
}
